import * as ko from "knockout";
import { searchCriteriaComplex, searchCriteriaItem } from "organized";

export class RequestIncidentSearchCriteria extends searchCriteriaComplex {
  //
  request_id: searchCriteriaItem<string>;
  model_id: searchCriteriaItem<string>;
  inc_states: searchCriteriaItem<string[]>;
  created_by: searchCriteriaItem<string>;
  req_status: searchCriteriaItem<string>;

  constructor(item) {
    super(item);

    this.request_id = new searchCriteriaItem<string>({ value: item?.request_id });
    this.model_id = new searchCriteriaItem<string>({ value: item?.model_id });
    this.inc_states = new searchCriteriaItem<string[]>({ value: item?.inc_states });
    this.created_by = new searchCriteriaItem<string>({ value: item?.created_by });
    this.req_status = new searchCriteriaItem<string>({ value: item?.req_status });
  }
}
